// extracted by mini-css-extract-plugin
export default {"container":"JjaH2VPa5ruA90tKF2zU","none":"RraP4aj2OQta8HAnLMjX"};